import { render, staticRenderFns } from "./EmIframe.vue?vue&type=template&id=398cd7bf"
import script from "./EmIframe.vue?vue&type=script&lang=ts"
export * from "./EmIframe.vue?vue&type=script&lang=ts"
import style0 from "./EmIframe.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default,IframeComponent: require('/app/components/base/IframeComponent/IframeComponent.vue').default})
